import '../style.scss';
import template from './fileUploadMini.html';
import FileUploadCtrl from '../fileUploadCtrl';

export default {
  template,
  bindings: {
    onCompleteAll: '&', // not required | {expression} // contains $response
    multiple: '<', // not required | {boolean} will tell if you allow multiple upload
    extensions: '<', // not required | {array} of extensions you wish to accept
    url: '<', // not required | {string}
    familyId: '<', // not required | {string}
    uploadType: '<', // not required | {string}
    autoUpload: '<', // not required | {boolean}
    invalidFileInfo: '=', // not required | {object} eg. {title: 'Bad file type', description: 'Should accept PNG'}
    customClickableComponent: '<',
    customUploadApi: '<',
    isSecured: '<?',
    uniqueId: '@?',
    isPresignedUrl: '<?',
  },
  controller: FileUploadCtrl,
  controllerAs: 'vm',
};
